<div class="absolute size-full brightness-50">
  @if ($ridHomeworkService.currentStop()?.background; as img) {
    <lp-img class="block size-full" [file]="img" fit="cover" />
  }
</div>
<div class="absolute size-full backdrop-blur-xs"></div>
